import { Component, Injector, OnInit, ViewEncapsulation } from '@angular/core';
import { ProductTypes } from '../../../../products/enums/product-types.enum';
import { BaseGridComponent } from '../base-grid/base-grid.component';
import { ColumnList } from '../constants/column-list.const';

@Component({
    selector: 'erv-equipment-schedule-grid',
    templateUrl: '../base-grid/base-grid.component.html',
    styleUrls: ['../base-grid/base-grid.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ErvEquipmentScheduleGridComponent
  extends BaseGridComponent
  implements OnInit
{
  constructor(protected injector: Injector) {
    super(injector);

    this.productType = ProductTypes.preconditioners;
  }

  ngOnInit(): void {
    this.columnList = ColumnList.getColumns(
      'model',
      'supplyVolume',
      'exhaustVolume',
      'summerDBWB',
      'winterDBWB',
      'winterASHRAE901',
      'mcaMop',
      'weight',
      'dimensions',
      'supplyTotalBhp',
      'supplySize',
      'exhaustBhp',
      'exhaustSize',
      'summerASHRAE901ERR',
      'supplyFanRPM',
      'supplyOutletdBA',
      'supplyOutletSones',
      'exhaustFRPM',
      'exhaustInletSoundDba',
      'exhaustFanInletSoundSones',
      'fanPower'
    );

    this.setVisibleColumns([
      'model',
      'supplyVolume',
      'exhaustVolume',
      'summerASHRAE901ERR',
      'summerDBWB',
      'winterDBWB',
      'winterASHRAE901',
      'mcaMop',
      'weight',
      'dimensions',
    ]);
  }
}
